<template>
  <div>
    <message :messages="messages"></message>
    <v-card>
      <v-card-title>
        <div class="body-2">{{labels.quoteInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.product" v-model="motorForm.product" :label="labels.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="labels.product" :error-messages="errors.collect('product')" v-validate="'required'" @input="doProduct"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.busCls" v-model="motorForm.busCls" :label="labels.busCls" item-text="label" item-value="value" data-vv-name="busCls" :data-vv-as="labels.busCls" :error-messages="errors.collect('busCls')" v-validate="'required'" @input="doBusCls" :loading="busClsLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.tariff" v-model="motorForm.tariff" :label="labels.tariff" item-text="label" item-value="value" data-vv-name="tariff" :data-vv-as="labels.tariff" :error-messages="errors.collect('tariff')" v-validate="'required'" @input="getNCDRates" :loading="tariffLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.cover" v-model="motorForm.cover" :label="labels.cover" item-text="label" item-value="value" data-vv-name="cover" :data-vv-as="labels.cover" :error-messages="errors.collect('cover')" v-validate="'required'" @input="doCover" :loading="coverLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="motorForm.startDate" :label="labels.startDate" v-validate="startDateValidation" :data-vv-as="labels.startDate" data-vv-name="startDate" :error-messages="errors.collect('startDate')" @input="doStartDate" :min="this.acceptDate" :max="maxStartDate"></cal-picker>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="motorForm.endDate" :label="labels.endDate" v-validate="endDateValidation" :data-vv-as="labels.endDate" data-vv-name="endDate" :error-messages="errors.collect('endDate')" :min="this.motorForm.startDate" :hint="daysCoverage"></cal-picker>
            </v-flex>
            <v-flex lg6 xs12>
              <v-layout row wrap>
                <v-flex xs7 v-if="isStaff">
                  <cal-picker v-model="acceptDate" :label="labels.acceptDate"  v-validate="'required'" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['motorQuoteAcceptDate'])" @input="doAcceptDate" ></cal-picker>
                  <!--cal-picker v-model="acceptDate" :label="labels.acceptDate"  v-validate="'required|accept_today_date'" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['motorQuoteAcceptDate'])" @input="doAcceptDate" :max="minStartDate"></cal-picker-->
                </v-flex>
                 <v-flex xs7 v-else>
                  <cal-picker v-model="acceptDate" :label="labels.acceptDate" v-validate="acceptDateValidation" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['motorQuoteAcceptDate'])" @input="doAcceptDate" :min="this.backDateLimit" ></cal-picker>
                  <!--cal-picker v-model="acceptDate" :label="labels.acceptDate" v-validate="acceptDateValidation" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['motorQuoteAcceptDate'])" @input="doAcceptDate" :min="this.backDateLimit" :max="minStartDate"></cal-picker-->
                </v-flex>
                <v-flex xs5>
                  <time-picker v-model="acceptTime" :label="labels.acceptTime" v-validate="'required'" :data-vv-as="labels.acceptTime" data-vv-name="acceptTime" :error-messages="errors.collect('acceptTime')" :readonly="!checkAccess(['motorQuoteAcceptDate'])" @input="doAcceptDate"></time-picker>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <template v-if="$mode !== 'ecics'">
        <v-divider></v-divider>
        <v-card-title>
          <div class="body-2">{{labels.clmInfo}}</div>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex lg6 xs12>
                <v-checkbox v-model="motorForm.exClm" :label="labels.exClm" data-vv-name="exClm" :data-vv-as="labels.exClm" :error-messages="errors.collect('exClm')" @change="doExClm" hide-details></v-checkbox>
              </v-flex>
              <v-flex lg6 xs12>
              </v-flex>
              <v-flex lg6 xs12 v-if="motorForm.exClm">
                <v-text-field v-int-mask="{intScale: 3}" v-model="motorForm.noClm" :label="labels.noClm" type="tel" :error-messages="errors.collect('noClm')" data-vv-name="noClm" :data-vv-as="labels.noClm" v-validate="'required|numeric|max_value:999|min_value:1'" :hint="getPermitStatusLabel(noClmStatus)" :persistent-hint="true" :class="getPermitStatusClass(noClmStatus)"></v-text-field>
              </v-flex>
              <v-flex lg6 xs12 v-if="motorForm.exClm">
                <v-text-field class="mavPrefix" v-num-mask v-model="motorForm.clmAmt" :label="labels.clmAmt" type="tel" :error-messages="errors.collect('clmAmt')" data-vv-name="clmAmt" :data-vv-as="labels.clmAmt" v-validate="'required|mask_decimal:2|mask_min_value:1|mask_max_value:99999999.99'" :prefix="$store.state.agency.quotation.commonInfo.currPrefix" :hint="getPermitStatusLabel(clmAmtStatus)" :persistent-hint="true" :class="getPermitStatusClass(clmAmtStatus)"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </template>
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.existingPolInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.ncdRate" v-model="motorForm.ncdRate" :label="labels.ncdRate" item-text="label" item-value="value" data-vv-name="ncdRate" :data-vv-as="labels.ncdRate" :error-messages="errors.collect('ncdRate')" v-validate="'required'" :loading="ncdRateLoading" append-icon="mdi-percent" :hint="getPermitStatusLabel(ncdRateStatus)" :persistent-hint="true" :class="getPermitStatusClass(ncdRateStatus)"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-title>
        <div class="body-2">{{labels.cpInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.campaign" v-model="motorForm.campaign" :label="labels.campaign" item-text="label" item-value="value" data-vv-name="campaign" :data-vv-as="labels.campaign" :error-messages="errors.collect('campaign')" clearable :loading="campaignLoading" @input="doCampaign"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.promotion" v-model="motorForm.promotion" :label="labels.promotion" item-text="label" item-value="value" data-vv-name="promotion" :data-vv-as="labels.promotion" :error-messages="errors.collect('promotion')" clearable :loading="promotionLoading"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="pt-3">
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed" :disabled="proceedLoading">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import toDate from 'date-fns/toDate'
import addYears from 'date-fns/addYears'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'
import differenceInDays from 'date-fns/differenceInDays'
import { QUOTE_MOTOR_PARAM, QUOTE_MOTOR_PARAM_GENERAL, AGENCY_QUOTATION_LIFECYCLE, QUOTE_MOTOR_PARAM_PERMSTATS, QUOTE_MOTOR_PARAM_VEHICLE } from '@/store/types'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { formatDisplayDate, formatDisplayTime, formatDisplayDateTime2 } from '@/utils/date'
import { removeFormatNumber } from '@/utils/number'
import { noClmStatus, clmAmtStatus } from './permStatus'
import { extractRecord } from '@/utils/extract'

export default {
  data() {
    return {
      labels: {
        product: 'Product*',
        busCls: 'Business Class*',
        tariff: 'Tariff*',
        cover: 'Type of Cover*',
        exClm: 'Claims in Past 3 Years?',
        noClm: 'No. of Claims*',
        clmAmt: 'Total Claim Amount*',
        ncdRate: 'Existing NCD*',
        startDate: 'Start Date*',
        endDate: 'End Date*',
        quoteInfo: 'Quotation Information',
        clmInfo: 'Claims Information',
        existingPolInfo: 'Existing Policy Information',
        acceptDate: 'Acceptance Date*',
        acceptTime: 'Time*',
        cpInfo: 'Campaign/Promotion',
        campaign: 'Campaign',
        promotion: 'Promotion'
      },
      motorForm: {
        product: undefined,
        busCls: undefined,
        tariff: undefined,
        cover: undefined,
        exClm: undefined,
        noClm: undefined,
        clmAmt: undefined,
        ncdRate: undefined,
        startDate: undefined,
        endDate: undefined,
        acceptDate: undefined,
        campaign: undefined,
        promotion: undefined
      },
      busClsLoading: false,
      tariffLoading: false,
      coverLoading: false,
      ncdRateLoading: false,
      campaignLoading: false,
      promotionLoading: false,
      acceptDate: undefined,
      acceptTime: undefined
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quoteParam() {
      return this.$store.state.agency.quotation.motorParam
    },
    globalForm() {
      return this.$store.state.agency.quotation.motorForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    isStaff() {
      return this.$store.state.agency.quotationSettings.isStaff
    },
    startDateValidation() {
      // return 'required|start_before_today|days_before_cover:' + this.daysBeforeCover
      return 'required|start_before_date:' + this.acceptDate + '|days_before_cover:' + this.daysBeforeCover
    },
    endDateValidation() {
      return 'required|start_enddate:' + this.motorForm.startDate
    },
    ncdRateStatus() {
      let result = 'A'
      if (this.motorForm.ncdRate !== null && this.quoteParam.ncdRate) {
        for (var i = 0; i < this.quoteParam.ncdRate.length; i++) {
          const ncdRate = this.quoteParam.ncdRate[i]
          if (ncdRate.value === this.motorForm.ncdRate) {
            result = ncdRate.permitStatus
            break
          }
        }
      }
      return result
    },
    noClmStatus() {
      if (this.motorForm.noClm !== null) {
        return noClmStatus(this.motorForm.noClm)
      } else {
        return 'A'
      }
    },
    clmAmtStatus() {
      if (this.motorForm.clmAmt !== null) {
        return clmAmtStatus(Number(removeFormatNumber(this.motorForm.clmAmt)))
      } else {
        return 'A'
      }
    },
    daysCoverage() {
      if (this.motorForm.startDate && this.motorForm.endDate) {
        return 'Days Covered: ' + (differenceInDays(toDate(this.motorForm.endDate), toDate(this.motorForm.startDate)) + 1)
      } else {
        return undefined
      }
    },
    daysBeforeCover() {
      if (this.motorForm.product) {
        const productParam = extractRecord(this.quoteParam.product, this.motorForm.product)
        if (productParam) {
          return productParam.maxDaysBeforeCover
        }
      }
      return undefined
    },
    minStartDate() {
      return new Date()
    },
    maxStartDate() {
      if (this.daysBeforeCover !== undefined) {
        let result = new Date()
        result.setHours(0, 0, 0, 0)
        result = addDays(result, this.daysBeforeCover)
        return result
      }
      return undefined
    },
    proceedLoading() {
      if (this.tariffLoading || this.coverLoading || this.ncdRateLoading || this.campaignLoading || this.promotionLoading) {
        return true
      } else {
        return false
      }
    },
    selectedProduct() {
      if (this.motorForm.product) {
        return extractRecord(this.quoteParam.product, this.motorForm.product)
      } else {
        return null
      }
    },
    backDateDays() {
      const product = this.selectedProduct
      if (product) {
        return product.backDateAcceptDays
      } else {
        return null
      }
    },
    backDateLimit() {
      if (this.backDateDays !== null || this.backDateDays !== undefined) {
        if (this.backDateDays === 0) {
          return new Date()
        } else {
          return subDays(new Date(), this.backDateDays)
        }
      } else return null
    },
    acceptDateValidation() {
      // const result = 'required|accept_back_date:' + this.backDateDays + '|accept_start_date:' + this.motorForm.startDate + '|accept_today_date'
      // return result
      // return 'required|accept_back_date:' + this.backDateDays + '|accept_today_date'
      return 'required|accept_back_date:' + this.backDateDays
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.motorForm.product = this.globalCommonForm.product
      this.motorForm.busCls = this.globalForm.busCls
      this.motorForm.tariff = this.globalForm.tariff
      this.motorForm.cover = this.globalForm.cover
      if (this.globalCommonForm.startDate) {
        this.motorForm.startDate = toDate(this.globalCommonForm.startDate)
      }
      if (this.globalCommonForm.endDate) {
        this.motorForm.endDate = toDate(this.globalCommonForm.endDate)
      }
      this.motorForm.exClm = this.globalForm.exClm
      this.motorForm.noClm = this.globalForm.noClm
      this.motorForm.clmAmt = this.globalForm.clmAmt
      this.motorForm.ncdRate = this.globalForm.ncdRate
      this.motorForm.acceptDate = this.globalCommonForm.acceptDate
      this.motorForm.campaign = this.globalCommonForm.campaign
      this.motorForm.promotion = this.globalCommonForm.promotion

      // Need break down acceptDate into date and time for input
      if (this.motorForm.acceptDate) {
        this.acceptDate = this.motorForm.acceptDate
        this.acceptTime = formatDisplayTime(this.motorForm.acceptDate)
      }

      // Check if there are already values in vuex form or if it is a fresh entry
      // For this case, we will just use product as an indicator (for review, there is already value saved)
      if (!this.motorForm.product) {
        if (this.quoteParam.product && this.quoteParam.product.length > 0) {
          // This is to load 1st value if its a fresh quotation
          this.motorForm.product = this.quoteParam.product[0].value
          this.doProduct()

          // Start and End Date
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          this.motorForm.startDate = today
          this.doStartDate()
        }
        this.motorForm.exClm = false

        this.$store.commit(QUOTE_MOTOR_PARAM_GENERAL)
      } else {
        // If there are already values in vuex, we will check if we still need to load Motor General Screen params
        if (!this.quoteParam.generalLoaded) {
          // doProduct will snowBall to get other params in general screen
          this.doProduct()

          this.$store.commit(QUOTE_MOTOR_PARAM_GENERAL)
        }
      }
    },
    doProduct() {
      if (this.motorForm.product) {
        this.getBusCls()
      } else {
        this.motorForm.busCls = undefined
        this.doBusCls()
      }

      if (this.motorForm.acceptDate && this.motorForm.product) {
        this.getCampaign()
      } else {
        this.motorForm.campaign = undefined
        this.doCampaign()
      }
    },
    async getBusCls() {
      const apiURI = this.$store.state.agency.quotation.menu.busCls
      if (apiURI) {
        try {
          this.busClsLoading = true
          const expand = {
            product: this.motorForm.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              busCls: data.data
            }
            this.$store.commit(QUOTE_MOTOR_PARAM, commitResult)
          }
          this.busClsLoading = false

          // Defaulting for busCls (Default 1st if no value was set)
          if (!this.motorForm.busCls && this.motorForm.product && this.quoteParam.busCls && this.quoteParam.busCls.length > 0) {
            this.motorForm.busCls = this.quoteParam.busCls[0].value
          }

          if (this.motorForm.busCls && this.quoteParam.busCls && this.quoteParam.busCls.length > 0) {
            // Check if the current busCls value is still valid
            let busClsIsValid = false
            for (var i = 0; i < this.quoteParam.busCls.length; i++) {
              const busCls = this.quoteParam.busCls[i]
              if (busCls.value === this.motorForm.busCls) {
                busClsIsValid = true
                break
              }
            }
            // Invalid BusCls (reset to undefined)
            if (!busClsIsValid) {
              this.motorForm.busCls = undefined
              this.doBusCls()
            } else {
              this.doBusCls()
            }
          } else {
            this.motorForm.busCls = undefined
            this.doBusCls()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.busClsLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doBusCls() {
      this.getTariff()
      this.getCover()
      this.getPermStatuses()

      // Instead of resetting model value, ill just flag it so value will be refreshed upon reaching vehicle page
      this.$store.commit(QUOTE_MOTOR_PARAM_VEHICLE, false)
    },
    async getTariff() {
      const apiURI = this.$store.state.agency.quotation.menu.tariff
      if (apiURI) {
        try {
          this.tariffLoading = true
          const expand = {
            busCls: this.motorForm.busCls
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              tariff: data.data
            }
            this.$store.commit(QUOTE_MOTOR_PARAM, commitResult)
          }
          this.tariffLoading = false

          // Defaulting for tariff (Based on buscls param)
          if (!this.motorForm.tariff && this.motorForm.busCls && this.quoteParam.busCls && this.quoteParam.busCls.length > 0) {
            const busClsParam = this.quoteParam.busCls.filter(busCls => busCls.value === this.motorForm.busCls)
            if (busClsParam) {
              this.motorForm.tariff = busClsParam[0].defTariff
            }
          }

          if (this.motorForm.tariff && this.quoteParam.tariff && this.quoteParam.tariff.length > 0) {
            // Check if the current tariff value is still valid
            let tariffIsValid = false
            for (var i = 0; i < this.quoteParam.tariff.length; i++) {
              const tariff = this.quoteParam.tariff[i]
              if (tariff.value === this.motorForm.tariff) {
                tariffIsValid = true
                break
              }
            }
            // Invalid tariff (reset to undefined)
            if (!tariffIsValid) {
              this.motorForm.tariff = undefined
              this.getNCDRates()
            } else {
              this.getNCDRates()
            }
          } else {
            this.motorForm.tariff = undefined
            this.getNCDRates()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.tariffLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getCover() {
      const apiURI = this.$store.state.agency.quotation.menu.cover
      if (apiURI) {
        try {
          this.coverLoading = true
          const expand = {
            busCls: this.motorForm.busCls
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              cover: data.data
            }
            this.$store.commit(QUOTE_MOTOR_PARAM, commitResult)
          }
          this.coverLoading = false

          // Defaulting 1st cover
          if (!this.motorForm.cover && this.quoteParam.cover && this.quoteParam.cover.length > 0) {
            this.motorForm.cover = this.quoteParam.cover[0].value
          }

          if (this.motorForm.cover && this.quoteParam.cover && this.quoteParam.cover.length > 0) {
            // Check if the current cover value is still valid
            let coverIsValid = false
            for (var i = 0; i < this.quoteParam.cover.length; i++) {
              const cover = this.quoteParam.cover[i]
              if (cover.value === this.motorForm.cover) {
                coverIsValid = true
                break
              }
            }
            // Invalid Cover (reset to undefined)
            if (!coverIsValid) {
              this.motorForm.cover = undefined
              this.doCover()
            } else {
              this.doCover()
            }
          } else {
            this.motorForm.cover = undefined
            this.doCover()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.coverLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doCover() {
      this.getNCDRates()
      this.getPermStatuses()
    },
    async getPermStatuses() {
      if (this.motorForm.busCls && this.motorForm.cover && this.motorForm.startDate) {
        const apiURI = this.$store.state.agency.quotation.menu.permStatus
        if (apiURI) {
          try {
            const expand = {
              busCls: this.motorForm.busCls,
              cover: this.motorForm.cover,
              startDate: formatDisplayDate(this.motorForm.startDate)
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            if (result.data) {
              const { data } = result
              this.$store.commit(QUOTE_MOTOR_PARAM_PERMSTATS, data.data)
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        } else {
          this.$snotify.error('Invalid API URL')
        }
      } else {
        this.$store.commit(QUOTE_MOTOR_PARAM_PERMSTATS, [])
      }
    },
    doStartDate() {
      if (this.motorForm.startDate) {
        // Add 1 year to end Date
        let endDate = addYears(this.motorForm.startDate, 1)
        endDate = subDays(endDate, 1)
        this.motorForm.endDate = endDate
      }
      // Refreshing NCDRates
      this.getNCDRates()

      // Refresh Perm status
      this.getPermStatuses()
    },
    async getNCDRates() {
      if (this.motorForm.busCls && this.motorForm.tariff && this.motorForm.cover && this.motorForm.startDate) {
        const apiURI = this.$store.state.agency.quotation.menu.ncdRate
        if (apiURI) {
          try {
            this.ncdRateLoading = true
            const expand = {
              busCls: this.motorForm.busCls,
              tariff: this.motorForm.tariff,
              cover: this.motorForm.cover,
              startDate: formatDisplayDate(this.motorForm.startDate)
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            if (result.data) {
              const { data } = result
              const commitResult = {
                ncdRate: data.data,
                ignoreValue: true
              }
              this.$store.commit(QUOTE_MOTOR_PARAM, commitResult)
            }
            this.ncdRateLoading = false

            // Defaulting of NCDRate
            if (!this.motorForm.ncdRate && this.quoteParam.ncdRate && this.quoteParam.ncdRate.length > 0) {
              this.motorForm.ncdRate = this.quoteParam.ncdRate[0].value
            } else if (this.motorForm.ncdRate && this.quoteParam.ncdRate && this.quoteParam.ncdRate.length > 0) {
              // Check if the current ncdRate value is still valid
              let ncdRateIsValid = false
              for (var i = 0; i < this.quoteParam.ncdRate.length; i++) {
                const ncdRate = this.quoteParam.ncdRate[i]
                if (ncdRate.value === this.motorForm.ncdRate) {
                  ncdRateIsValid = true
                  break
                }
              }
              if (!ncdRateIsValid) {
                this.motorForm.ncdRate = undefined
              }
            } else {
              this.motorForm.ncdRate = undefined
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
            this.ncdRateLoading = false
          }
        } else {
          this.$snotify.error('Invalid API URL')
        }
      } else {
        const commitResult = {
          ncdRate: []
        }
        this.motorForm.ncdRate = undefined
        this.$store.commit(QUOTE_MOTOR_PARAM, commitResult)
      }
    },
    doExClm() {
      if (!this.motorForm.exClm) {
        this.motorForm.noClm = undefined
        this.motorForm.clmAmt = undefined
      }
    },
    doAcceptDate() {
      // Format Accept Date
      if (this.checkAccess(['motorQuoteAcceptDate'])) {
        if (this.acceptDate && this.acceptTime && this.acceptTime.length === 5) {
          const hr = this.acceptTime.substring(0, 2)
          const min = this.acceptTime.substring(3, 5)
          this.acceptDate = toDate(this.acceptDate)
          this.acceptDate.setHours(hr)
          this.acceptDate.setMinutes(min)
          this.motorForm.acceptDate = this.acceptDate
        }
      }
      if (this.motorForm.product && this.motorForm.acceptDate) {
        this.getCampaign()
      } else {
        this.motorForm.campaign = undefined
        this.doCampaign()
      }
    },
    async getCampaign() {
      const apiURI = this.$store.state.agency.quotation.menu.campaign
      if (apiURI) {
        try {
          const expand = {
            product: this.motorForm.product,
            intermediary: this.globalCommonForm.intermediary,
            acceptDate: formatDisplayDateTime2(this.motorForm.acceptDate)
          }
          this.campaignLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              campaign: data.data
            }
            this.$store.commit(QUOTE_MOTOR_PARAM, commitResult)
          }
          this.campaignLoading = false

          if (this.motorForm.campaign && this.quoteParam.campaign && this.quoteParam.campaign.length > 0) {
            // Check if the current campaign value is still valid
            let campaignIsValid = false
            for (var i = 0; i < this.quoteParam.campaign.length; i++) {
              const campaign = this.quoteParam.campaign[i]
              if (campaign.value === this.motorForm.campaign) {
                campaignIsValid = true
                break
              }
            }
            // Invalid Campaign (reset to undefined)
            if (!campaignIsValid) {
              this.motorForm.campaign = undefined
            } else { }
          } else {
            this.motorForm.campaign = undefined
          }
          // Do campaign (get promotion)
          this.doCampaign()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.campaignLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doCampaign() {
      if (this.motorForm.campaign && this.motorForm.acceptDate) {
        this.getPromotion()
      } else {
        this.motorForm.promotion = undefined
      }
    },
    async getPromotion() {
      const apiURI = this.$store.state.agency.quotation.menu.promotion
      if (apiURI) {
        try {
          const expand = {
            campaign: this.motorForm.campaign,
            acceptDate: formatDisplayDateTime2(this.motorForm.acceptDate)
          }
          this.promotionLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              promotion: data.data
            }
            this.$store.commit(QUOTE_MOTOR_PARAM, commitResult)
          }
          this.promotionLoading = false

          if (this.motorForm.promotion && this.quoteParam.promotion && this.quoteParam.promotion.length > 0) {
            // Check if the current promotion value is still valid
            let promotionIsValid = false
            for (var i = 0; i < this.quoteParam.promotion.length; i++) {
              const promotion = this.quoteParam.promotion[i]
              if (promotion.value === this.motorForm.promotion) {
                promotionIsValid = true
                break
              }
            }
            // Invalid Promotion (reset to undefined)
            if (!promotionIsValid) {
              this.motorForm.promotion = undefined
            }
          } else {
            this.motorForm.promotion = undefined
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.resetMessages()
            this.message(data)
          }
          this.promotionLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if ((this.motorForm.campaign && this.motorForm.promotion) || (!this.motorForm.campaign && !this.motorForm.promotion)) {
            this.$store.dispatch('motorQuoteGeneral', this.motorForm)
            this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
            this.$router.push({ name: 'motorQuoteDriver' })
          } else {
            this.errorMessage('Please select a promotion if this quotation is participating in a campaign')
            this.promptFieldCheck()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        await this.$store.dispatch('motorQuoteGeneral', this.motorForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 1) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ],
  props: {
    getPermitStatusLabel: {
      type: Function,
      default: function (status) {
        return ''
      }
    },
    getPermitStatusClass: {
      type: Function,
      default: function (status) {
        return ''
      }
    }
  }
}
</script>

<style lang="scss">
</style>
